var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-ignore
import { useForm, Head, usePage } from '@inertiajs/react';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { useRoute } from 'ziggy-js';
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard';
import JetValidationErrors from '@/Jetstream/ValidationErrors';
import { router } from '@inertiajs/react';
import axios from "axios";
import InputLabel from "@/Jetstream/Label";
import InputError from "@/Jetstream/InputError";
import PrimaryButton from "@/Jetstream/Button";
import SecondaryButton from "@/Jetstream/SecondaryButton";
import { ArrowPathIcon } from "@heroicons/react/24/outline";
import AuthCode from "react-auth-code-input";
import { Ziggy } from "@/ziggy";
export default function TwoFactorChallenge() {
    var _a, _b;
    var route = useRoute(Ziggy);
    var _c = useState(false), recovery = _c[0], setRecovery = _c[1];
    var form = useForm({
        code: '',
        recovery_code: '',
    });
    var recoveryCodeRef = useRef(null);
    var codeRef = useRef(null);
    var page = usePage();
    var _d = useState(false), enabling = _d[0], setEnabling = _d[1];
    var _e = useState(false), disabling = _e[0], setDisabling = _e[1];
    var _f = useState(null), qrCode = _f[0], setQrCode = _f[1];
    var _g = useState([]), recoveryCodes = _g[0], setRecoveryCodes = _g[1];
    var _h = useState(false), confirming = _h[0], setConfirming = _h[1];
    var _j = useState(null), setupKey = _j[0], setSetupKey = _j[1];
    var confirmationForm = useForm({
        code: '',
    });
    // @ts-ignore
    var twoFactorEnabled = !enabling && ((_b = (_a = page.props) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.two_factor_enabled_real);
    function toggleRecovery(e) {
        e.preventDefault();
        setRecovery(true);
        setTimeout(function () {
            var _a, _b;
            if (recovery) {
                (_a = recoveryCodeRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                form.setData('code', '');
            }
            else {
                (_b = codeRef.current) === null || _b === void 0 ? void 0 : _b.focus();
                form.setData('recovery_code', '');
            }
        }, 100);
    }
    function onSubmit(e) {
        e.preventDefault();
        form.post(route('two-factor.login'));
    }
    useEffect(function () {
        enableTwoFactorAuthentication();
    }, []);
    function enableTwoFactorAuthentication() {
        setEnabling(true);
        axios.post('/user/two-factor-authentication', {}).then(function () {
            Promise.all([
                showQrCode(),
                showSetupKey(),
                showRecoveryCodes(),
            ]).then(function () {
                setEnabling(false);
                setConfirming(true);
            });
        });
        // router.post(
        //     '/user/two-factor-authentication',
        //     {},
        //     {
        //         preserveScroll: true,
        //         onSuccess() {
        //             return Promise.all([
        //                 showQrCode(),
        //                 showSetupKey(),
        //                 showRecoveryCodes(),
        //             ]);
        //         },
        //         onFinish() {
        //             setEnabling(false);
        //             setConfirming(true);
        //         },
        //     },
        // );
    }
    function showSetupKey() {
        return axios.get('/user/two-factor-secret-key').then(function (response) {
            setSetupKey(response.data.secretKey);
        });
    }
    function confirmTwoFactorAuthentication() {
        confirmationForm.post('/user/confirmed-two-factor-authentication', {
            preserveScroll: true,
            preserveState: true,
            errorBag: 'confirmTwoFactorAuthentication',
            onSuccess: function () {
                setConfirming(false);
                setQrCode(null);
                setSetupKey(null);
            },
        });
    }
    function showQrCode() {
        return axios.get('/user/two-factor-qr-code').then(function (response) {
            setQrCode(response.data.svg);
        });
    }
    function showRecoveryCodes() {
        return axios.get('/user/two-factor-recovery-codes').then(function (response) {
            setRecoveryCodes(response.data);
        });
    }
    function regenerateRecoveryCodes() {
        axios.post('/user/two-factor-recovery-codes').then(function () {
            showRecoveryCodes();
        });
    }
    function disableTwoFactorAuthentication() {
        setDisabling(true);
        router.delete('/user/two-factor-authentication', {
            preserveScroll: true,
            onSuccess: function () {
                setDisabling(false);
                setConfirming(false);
            },
        });
    }
    return (_jsxs(JetAuthenticationCard, __assign({ width: "max-w-xl" }, { children: [_jsx(Head, { title: "Two-factor confirmation" }), _jsx("div", { className: "mb-4 text-sm text-gray-600" }), _jsx(JetValidationErrors, { className: "mb-4" }), _jsxs("div", { children: [(function () {
                        if (confirming) {
                            return (_jsx("h3", __assign({ className: "text-lg font-medium text-gray-900 dark:text-gray-100" }, { children: "Finish enabling two factor authentication to secure your account" })));
                        }
                    })(), twoFactorEnabled || confirming ? (_jsxs("div", { children: [qrCode ? (_jsxs("div", { children: [_jsx("div", __assign({ className: "mt-4 max-w-xl text-sm text-gray-600 dark:text-gray-400" }, { children: confirming ? (_jsxs(_Fragment, { children: [_jsx("p", __assign({ className: "font-semibold mb-2" }, { children: "To finish enabling two factor authentication, scan the following QR code using your phone's authenticator application or enter the setup key and provide the generated OTP code." })), _jsx("p", __assign({ className: " mb-2" }, { children: "You can use one of the following apps if you do not have one already installed on your mobile device:" })), _jsxs("div", { children: [_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", fill: "currentColor", className: "inline-block h-4 w-4 text-gray-800" }, { children: _jsx("path", { d: "M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z" }) })), " ", _jsx("strong", { children: "Android:" }), " ", _jsx("a", __assign({ className: "underline ", target: "_blank", href: "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" }, { children: "Google Authenticator" })), ",", " ", _jsx("a", __assign({ className: "underline ", target: "_blank", href: "https://play.google.com/store/apps/details?id=com.azure.authenticator" }, { children: "Microsoft Authenticator" })), ",", " ", _jsx("a", __assign({ className: "underline ", target: "_blank", href: "https://play.google.com/store/apps/details?id=com.authy.authy" }, { children: "Twilio Authy" }))] }), _jsxs("div", { children: [_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 384 512", fill: "currentColor", className: "inline-block h-4 w-4 text-gray-800" }, { children: _jsx("path", { d: "M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" }) })), " ", _jsx("strong", { children: "iPhone:" }), " ", _jsx("a", __assign({ className: "underline ", target: "_blank", href: "https://apps.apple.com/us/app/google-authenticator/id388497605" }, { children: "Google Authenticator" })), ",", " ", _jsx("a", __assign({ className: "underline ", target: "_blank", href: "https://apps.apple.com/us/app/microsoft-authenticator/id983156458" }, { children: "Microsoft Authenticator" })), ",", " ", _jsx("a", __assign({ className: "underline ", target: "_blank", href: "https://apps.apple.com/us/app/twilio-authy/id494168017" }, { children: "Twilio Authy" }))] })] })) : (_jsx("p", { children: "Two factor authentication is now enabled. Scan the following QR code using your phone's authenticator application or enter the setup key." })) })), _jsx("div", { className: "mt-4", dangerouslySetInnerHTML: { __html: qrCode || '' } }), setupKey && (_jsx("div", __assign({ className: "mt-4 max-w-xl text-sm text-gray-600 dark:text-gray-400" }, { children: _jsxs("p", __assign({ className: "font-semibold" }, { children: ["Setup Key:", ' ', _jsx("span", { dangerouslySetInnerHTML: { __html: setupKey || '' } })] })) }))), confirming && (_jsxs("div", __assign({ className: "mt-4" }, { children: [_jsx(InputLabel, { htmlFor: "code", value: "Code" }), _jsx("div", __assign({ className: "two-fa-input" }, { children: _jsx(AuthCode, { allowedCharacters: 'numeric', onChange: function (value) { return confirmationForm.setData('code', value); } }) })), _jsx(InputError, { message: confirmationForm.errors.code, className: "mt-2" })] })))] })) : null, recoveryCodes.length > 0 && !confirming ? (_jsxs("div", { children: [_jsx("div", __assign({ className: "mt-4 max-w-xl text-sm text-gray-600 dark:text-gray-400" }, { children: _jsx("p", __assign({ className: "font-semibold" }, { children: "Store these recovery codes in a secure password manager. They can be used to recover access to your account if your two factor authentication device is lost." })) })), _jsx("div", __assign({ className: "grid gap-1 max-w-xl mt-4 px-4 py-4 font-mono text-sm bg-gray-100 dark:bg-gray-900 rounded-lg" }, { children: recoveryCodes.map(function (code) { return (_jsx("div", { children: code }, code)); }) }))] })) : null] })) : null, _jsx("div", __assign({ className: "mt-5" }, { children: twoFactorEnabled || confirming && _jsxs("div", { children: [confirming ? (_jsx(PrimaryButton, __assign({ onClick: confirmTwoFactorAuthentication, className: classNames('mr-3', { 'opacity-25': enabling }), disabled: enabling }, { children: "Confirm" }))) : null, recoveryCodes.length > 0 && !confirming ? (_jsx(SecondaryButton, __assign({ onClick: regenerateRecoveryCodes, className: "mr-3" }, { children: "Regenerate Recovery Codes" }))) : null, recoveryCodes.length === 0 && !confirming ? (_jsx(SecondaryButton, __assign({ onClick: showRecoveryCodes, className: "mr-3" }, { children: "Show Recovery Codes" }))) : null] }) }))] }), enabling && _jsx("div", __assign({ className: "mt-5 flex justify-center" }, { children: _jsx(ArrowPathIcon, { className: "animate-spin h-8 w-8 text-gray-400" }) }))] })));
}
